import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import Main from './Main';
import 'helpers/initFA';
import { ApolloProvider } from '@apollo/client';
import client from 'client/apolloClient';

const container = document.getElementById('main');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <Main>
        <App />
      </Main>
    </ApolloProvider>
  </React.StrictMode>
);
